import {
  CredentialResponse,
  GoogleLogin,
  GoogleLoginProps,
} from "@react-oauth/google";
import { emitAnalyticsTrackingEvent } from "../../../../utils/analyticsUtils";
import { toast } from "react-toastify";
import { darkModeAtom } from "../../../../atoms/user/darkModeAtom";
import { useAtomValue } from "jotai";

interface SignUpOrInWithGoogleProps extends Pick<GoogleLoginProps, "text"> {
  onSuccess: (credentialResponse: CredentialResponse) => void;
}

export const SignUpOrInWithGoogle = ({
  onSuccess = () => {},
  text,
}: SignUpOrInWithGoogleProps) => {
  const darkMode = useAtomValue(darkModeAtom);
  return (
    <GoogleLogin
      click_listener={() => {
        emitAnalyticsTrackingEvent("auth_click_on_google_login", {});
      }}
      onSuccess={onSuccess}
      onError={() => {
        toast.error("Unable to sign in via Google.");
      }}
      shape={"rectangular"}
      // No way to custom style this since its in an iFrame
      // Max width by the system is 400px, 310px looks best on mobile and desktop, looks terrible on tablet
      width={"310px"}
      text={text}
      useOneTap
      theme={darkMode ? "filled_black" : "outline"}
      use_fedcm_for_prompt
    />
  );
};
